var _circle, _path, _path2, _circle2, _path3, _rect, _path4, _line, _line2, _line3, _line4, _line5, _line6, _line7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 66,
    viewBox: "0 0 101 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.0005 7.46631V20.533",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4668 14H93.5335",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 52,
    r: 13.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4668 52H93.5335",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 31.5,
    width: 49.5,
    height: 30,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 8C0.75 5.65279 2.65279 3.75 5 3.75H47.5C49.8472 3.75 51.75 5.65279 51.75 8V58C51.75 60.3472 49.8472 62.25 47.5 62.25H5C2.65279 62.25 0.75 60.3472 0.75 58V8Z",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.75,
    y1: 9.25,
    x2: 51.25,
    y2: 9.25,
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 47.25,
    y1: 9.75,
    x2: 47.25,
    y2: 33.75,
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 5.25,
    y1: 9.75,
    x2: 5.25,
    y2: 33.75,
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: 15.75,
    x2: 51.75,
    y2: 15.75,
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: 21.75,
    x2: 51.75,
    y2: 21.75,
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: 27.75,
    x2: 51.75,
    y2: 27.75,
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: 33.75,
    x2: 51.75,
    y2: 33.75,
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon2);
export default __webpack_public_path__ + "static/media/faq-icon2.98ebef851df7f5641ed8d8a6e1651f01.svg";
export { ForwardRef as ReactComponent };